module.exports = __webpack_public_path__ + "static/img/yczb.c778986a.png";